import { storage } from './storage';

export const AUTH_TOKEN_KEY = 'authToken';

export function normalizePhone(input) {
  const digits = String(input).replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('964')) return digits;
  if (digits.startsWith('0')) return `964${digits.slice(1)}`;
  return digits;
}

export function extractAuthPayload(json) {
  const token = json?.token ?? json?.data?.token ?? json?.access_token ?? null;
  const user = json?.user ?? json?.data?.user ?? null;
  const registered =
    json?.registered ??
    json?.is_registered ??
    json?.user_exists ??
    json?.data?.registered ??
    null;

  return { token, user, registered, message: json?.message ?? null };
}

export async function readJsonSafe(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

export async function getApiErrorMessage(response, fallback) {
  const json = await readJsonSafe(response);
  if (json.message) return json.message;
  const firstError = json.errors ? Object.values(json.errors).flat()[0] : null;
  return firstError ?? fallback;
}

export async function saveAuthSession({ token, user }) {
  const pairs = [['login', 'true']];

  if (token) {
    pairs.push([AUTH_TOKEN_KEY, token]);
  }

  if (user) {
    pairs.push(['user', JSON.stringify(user)]);
    if (user.name) {
      pairs.push(['userName', user.name]);
    }
  }

  await storage.multiSet(pairs);
}

export async function completeAuthSession({ token, user }) {
  await saveAuthSession({ token, user });
}

export async function clearAuthSession() {
  await storage.multiRemove(['user', 'login', AUTH_TOKEN_KEY, 'userName']);
}

export async function getAuthToken() {
  return storage.getItem(AUTH_TOKEN_KEY);
}

export async function getStoredUser() {
  try {
    const raw = await storage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export async function isUserLoggedIn() {
  const entries = await storage.multiGet([AUTH_TOKEN_KEY, 'login']);
  const token = entries.find(([k]) => k === AUTH_TOKEN_KEY)?.[1];
  const loginFlag = entries.find(([k]) => k === 'login')?.[1];
  return Boolean(token && loginFlag === 'true');
}
